import { useOne } from 'context/ResourceProvider/hooks/useOne';
import React from 'react';
import { Spin, List } from 'antd';
import classes from './Detail.module.scss';
import { RequirementItem } from './RequirementItem/index';
import { Tag } from 'components/Molecules/Tag/index';

export const DetailQualityRequirementTemplate = ({ id }) => {
  const { data, loading } = useOne({
    resource: 'quality-requirements/templates',
    id,
    skip: !id,
  });

  return (
    <Spin spinning={loading}>
      <div className={classes.container}>
        <List
          className={classes.listRequirement}
          dataSource={data ? data.requirements : []}
          renderItem={(record) => {
            return (
              <List.Item>
                <RequirementItem requirement={record} />
              </List.Item>
            );
          }}
        />
      </div>
    </Spin>
  );
};
